var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 56,
    viewBox: "0 0 80 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2857 37.1615H19.4393L15.8051 23.2966C15.6326 22.6589 15.2663 22.095 14.7275 21.8293C13.383 21.1615 11.9014 20.63 10.2852 20.3619V19.8281H18.0924C19.1699 19.8281 19.9781 20.63 20.1127 21.5612L21.9984 31.5624L26.8425 19.8281H31.5542L24.2857 37.1615ZM34.248 37.1615H29.6709L33.4398 19.8281H38.0169L34.248 37.1615ZM43.9386 24.6313C44.0732 23.6978 44.8814 23.164 45.8242 23.164C47.3058 23.0299 48.9197 23.298 50.2666 23.9635L51.0747 20.2315C49.7278 19.6977 48.2463 19.4297 46.9017 19.4297C42.4593 19.4297 39.2268 21.8306 39.2268 25.1628C39.2268 27.6978 41.5165 29.0288 43.1328 29.8306C44.8814 30.6302 45.5548 31.164 45.4201 31.9635C45.4201 33.1628 44.0732 33.6966 42.7287 33.6966C41.1124 33.6966 39.4962 33.2969 38.017 32.629L37.2088 36.3633C38.8251 37.0288 40.5737 37.2969 42.19 37.2969C47.1711 37.4286 50.2666 35.03 50.2666 31.4297C50.2666 26.8959 43.9386 26.6302 43.9386 24.6313ZM66.2851 37.1615L62.6508 19.8281H58.7472C57.9391 19.8281 57.131 20.3619 56.8616 21.1615L50.1318 37.1615H54.8436L55.7841 34.6289H61.5733L62.1121 37.1615H66.2851ZM59.4205 24.4961L60.765 31.0287H56.9961L59.4205 24.4961Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.cf78b7e86b0c3439c66d70cdff008225.svg";
export { ForwardRef as ReactComponent };